// import 'bootstrap/dist/js/bootstrap'
import 'bootstrap/dist/js/bootstrap.min'
import 'bootstrap4-datetimepicker/src/js/bootstrap-datetimepicker'

